import type { VisualizationKind } from './VisualizationKind';

/** Значення поля «Інструмент» аналізу → вид діаграми (прототип: Fishbone → fishbone, SWOT → swot, TOWS → tows). */
export const VIZ_TOOLS: Readonly<Record<string, VisualizationKind>> = { Fishbone: 'fishbone', SWOT: 'swot', TOWS: 'tows' };
